export enum DiagnosticMessageType {
  error = 'error',
  warning = 'warning',
}

export type DiagnosticMessage = {
  type: DiagnosticMessageType;
  text: string;
  dismissible: boolean;
};

export type DiagnosticMessageEntity = DiagnosticMessage & { id: string };
